import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  check(event) {
    event.preventDefault()
    this.performAction(event.currentTarget)
  }

  skip(event) {
    event.preventDefault()
    this.performAction(event.currentTarget)
  }

  unskip(event) {
    event.preventDefault()
    this.performAction(event.currentTarget)
  }

  performAction(link) {
    const url = link.dataset.url

    fetch(url, {
      method: 'POST',
      headers: {
        'X-CSRF-Token': document.querySelector('[name="csrf-token"]').content,
        'Accept': 'application/json'
      }
    })
    .then(response => {
      window.location.reload()
    })
    .catch(error => {
      console.error('Error performing due action:', error)
    })
  }
}

